var map = {
  "./assets/favicons-dev/android-chrome-192x192.png": "244143",
  "./assets/favicons-dev/android-chrome-512x512.png": "954087",
  "./assets/favicons-dev/apple-touch-icon-120x120.png": "475203",
  "./assets/favicons-dev/apple-touch-icon-152x152.png": "108247",
  "./assets/favicons-dev/apple-touch-icon-180x180.png": "175799",
  "./assets/favicons-dev/apple-touch-icon-60x60.png": "139915",
  "./assets/favicons-dev/apple-touch-icon-76x76.png": "95221",
  "./assets/favicons-dev/apple-touch-icon.png": "689864",
  "./assets/favicons-dev/browserconfig.xml": "1110",
  "./assets/favicons-dev/favicon-16x16.png": "463431",
  "./assets/favicons-dev/favicon-32x32.png": "169311",
  "./assets/favicons-dev/favicon-alert-16x16.png": "992026",
  "./assets/favicons-dev/favicon-alert-32x32.png": "832270",
  "./assets/favicons-dev/favicon-alert.ico": "208717",
  "./assets/favicons-dev/favicon.ico": "747008",
  "./assets/favicons-dev/mstile-144x144.png": "975095",
  "./assets/favicons-dev/mstile-150x150.png": "174643",
  "./assets/favicons-dev/mstile-310x150.png": "115165",
  "./assets/favicons-dev/mstile-310x310.png": "125079",
  "./assets/favicons-dev/mstile-70x70.png": "134201",
  "./assets/favicons-dev/safari-pinned-tab.svg": "899048",
  "./assets/favicons-dev/site.webmanifest": "164717",
  "./assets/favicons-dev/upc-favicon.ico": "389069"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = () => (Object.keys(map));
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = 631708;
